export default "__VITE_ASSET__CrnmrjsW__"